// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tKALQ","colMin":"styles_colMin__2E6ot"};